export default __webpack_public_path__ + "static/media/loginimage.ce0c7410.jpg";